<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
<template>
    <v-container fluid class="pa-0">
        <v-row dense>
            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <v-select 
                    dense
                    v-model="verminNo" 
                    :label="item.name" 
                    outlined 
                    hide-details
                    :items="vermins" 
                    item-text="name"
                    item-value="verminNo"
                    clearable
                    :readonly="!canEdit" />
            </v-col>
            <v-scale-transition>
                <v-col v-if="verminNo == null" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <v-text-field
                        v-model="verminName" 
                        clearable
                        label="害虫名" 
                        outlined
                        :readonly="!canEdit"
                        hide-details 
                        type="text" 
                        dense />
                </v-col>
            </v-scale-transition>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            value: {
                type: Object,
                default: function () {
                    return {
                        verminNo: null,
                        verminName: ""
                    }
                }
            },
            /** 作業記録項目種類 */
            item: null,
            /** 編集可否 */
            canEdit: false,
        },
        data: function () {
            return {
                verminNo: null,
                verminName: ""
            }
        },
        computed: {
            editValue: {
                get: function () {
                    return this.$props.value
                },
                set: function (v) {
                    this.$emit("input", v)
                }
            },
            vermins: function () {
                return this.$store.getters["managementItems/verminsArray"]
            },
        },
        watch: {
            editValue: {
                handler: function (value, old) {
                    console.log(value)
                },
                deep: true
            },
            /**
             * 病気No.の監視
             */
            verminNo: function (value, old) {
                if (value == undefined) {
                    this.value.verminNo = null
                } else {
                    this.value.verminNo = value
                }
                if (value != null) {
                    this.verminName = ""
                }
            },
            /**
             * 病名の監視
             */
            verminName: function (value, old) {
                if (value == undefined) {
                    this.value.verminName = ""
                } else {
                    this.value.verminName = value
                }
            }
        },
        created: function () {
            if (this.editValue == "") {
                this.editValue = {
                    verminNo: null,
                    verminName: ""
                }
            }
            this.verminNo = this.editValue.verminNo
            this.verminName = this.editValue.verminName
        }
    }
</script>
